import React from 'react';
import { LightingServiceDetail } from '../components/christmas/LightingServiceDetail';
import { lightingCategories } from '../data/christmasLighting';
export function ResidentialLighting() {
  const category = lightingCategories.find(c => c.slug === 'residential');
  if (!category) return null;
  return <LightingServiceDetail category={category} data-id="element-450" data-mp="1esc4475ezog8" />;
}